import { useContext } from "react";
import WelcomePage from "./welcome-page/welcome-page";
import { MultiStepperStyled } from "./multistepper.styles";
import FormContainer from "./form-containers/form-container";
import { UserAppointmentContext } from "../context/user-appointment-context";

const MultiStepper = () => {
  const {
    state: { activeStep },
  } = useContext(UserAppointmentContext);
  return (
    <MultiStepperStyled>
      <div className="container-wrapper">
        {activeStep === 1 && <WelcomePage />}
        {activeStep > 1 && <FormContainer />}
      </div>
    </MultiStepperStyled>
  );
};

export default MultiStepper;
